import axios from "axios";

const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

export const resendEmailVerificationRequest = async () => {
    await axios.post(
        route("register.verification.resend"),
        {},
        csrfToken
            ? {
                  headers: {
                      "X-CSRF-TOKEN": csrfToken,
                  },
              }
            : undefined
    );
};

export default resendEmailVerificationRequest;
